import mountReactContainer from '../../../../shared/js/react-mounting'
import Description from './Description'
import Photos from './photos/Photos'

document.addEventListener('DOMContentLoaded', () => {
  // Load related products as HTML for "add to cart" dialog display since we
  // don’t want to rebuild associated widget component in JS.
  const relatedProductsHTML = document.getElementById(
    'js-add-to-cart-related-products'
  )?.innerHTML

  // Also load product guide, if any
  const guideHTML = document.getElementById('js-guide-content')?.innerHTML

  mountReactContainer({
    id: 'js-product-description',
    component: Description,
    relatedProductsHTML,
    guideHTML,
  })

  mountReactContainer({
    id: 'js-product-photos',
    component: Photos,
  })
})
